import { PRODUCT_IDS } from '@adsk/alloy-provider';
const PRODUCT_TITLES = {
  [PRODUCT_IDS.MODEL_COORDINATION]: 'Autodesk Model Coordination',
  [PRODUCT_IDS.DESIGN_COLLABORATION]: 'Autodesk Design Collaboration',
  [PRODUCT_IDS.QUANTIFY]: 'Autodesk Quantify',
  [PRODUCT_IDS.TAKEOFF]: 'Autodesk Takeoff',
  [PRODUCT_IDS.COST]: 'Autodesk Cost',
  [PRODUCT_IDS.INSIGHT]: 'Autodesk Insight',
  [PRODUCT_IDS.BUILD]: 'Autodesk Build',
  [PRODUCT_IDS.DOCS]: 'Autodesk Docs',
  [PRODUCT_IDS.ACCOUNT_ADMINISTRATION]: 'Autodesk Account Administration',
  [PRODUCT_IDS.PROJECT_ADMINISTRATION]: 'Autodesk Project Administration',
  [PRODUCT_IDS.AUTOSPECS]: 'Autodesk AutoSpecs',
  [PRODUCT_IDS.BUILDING_CONNECTED]: 'BuildingConnected'
};
const getProductTitle = key => {
  return PRODUCT_TITLES[key];
};
export default getProductTitle;
//# sourceMappingURL=getProductTitle.js.map